var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{attrs:{"sitekey":_vm.siteKey,"load-recaptcha-script":true},on:{"verify":_vm.handleSuccess,"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }